document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll("[data-faq-split]");
  if (!sections.length) return;

  const closeItem = (item) => {
    const answer = item.querySelector(".faq-split__answer");
    const button = item.querySelector(".faq-split__question");
    const icon = item.querySelector(".faq-split__icon");
    item.classList.remove("is-open");
    button?.setAttribute("aria-expanded", "false");
    if (answer) answer.style.maxHeight = "0px";
    if (icon) icon.textContent = "+";
  };

  const openItem = (item) => {
    const answer = item.querySelector(".faq-split__answer");
    const button = item.querySelector(".faq-split__question");
    const icon = item.querySelector(".faq-split__icon");
    item.classList.add("is-open");
    button?.setAttribute("aria-expanded", "true");
    if (answer) answer.style.maxHeight = answer.scrollHeight + "px";
    if (icon) icon.textContent = "−";
  };

  sections.forEach((section) => {
    const items = Array.from(section.querySelectorAll(".faq-split__item"));
    if (!items.length) return;

    items.forEach((item) => {
      const button = item.querySelector(".faq-split__question");
      if (!button) return;

      button.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");
        items.forEach((it) => closeItem(it));
        if (!isOpen) openItem(item);
      });
    });

    // Initial state sizing
    items.forEach((item) => {
      if (item.classList.contains("is-open")) {
        openItem(item);
      } else {
        closeItem(item);
      }
    });

    window.addEventListener("resize", () => {
      items.forEach((item) => {
        if (item.classList.contains("is-open")) {
          const answer = item.querySelector(".faq-split__answer");
          if (answer) answer.style.maxHeight = answer.scrollHeight + "px";
        }
      });
    });
  });
});
